import React from 'react';
import FormHelperText from '@mui/material/FormHelperText';
import { FormControl, Select, InputLabel } from '@mui/material';

type IGenericDropdownProps = {
  onChange: (event: any) => void;
  id: string;
  label: string;
  value: string;
  disabled?: boolean;
  items: any[];
  error?: boolean;
  onClose?: any;
  onBlur?: any;
  helperText?: any;
};

export function GenericDropdown({
  label,
  items,
  onBlur,
  onChange,
  helperText,
  error,
  ...props
}: IGenericDropdownProps) {
  return (
    <FormControl fullWidth error={error}>
      <InputLabel id={`${label}-dropdown-label`}>{label}</InputLabel>
      <Select
        labelId={`${label}-dropdown-label`}
        name={props.id} // need to check on why this is not the same
        onChange={onChange}
        onBlur={onBlur}
        label={label}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      >
        {items}
      </Select>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
}
